import React from 'react';

import { useMatches } from '@tanstack/react-router';

export const TopRightFunction = () => {
  const matches = useMatches();
  const functions = matches.filter((m) => m.staticData?.topRightFunction);

  if (functions.length === 0) return null;
  return (
    <nav className="flex items-center" aria-label="Top Right Function">
      {functions.map((match) => {
        const FunctionComponent = match.staticData?.topRightFunction;
        const content =
          typeof FunctionComponent === 'function' ? <FunctionComponent /> : FunctionComponent;
        return <React.Fragment key={match.id}>{content}</React.Fragment>;
      })}
    </nav>
  );
};
